namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_notebook, {

		Content_scroll: {
			border: {
				style: 'dashed',
				width: '2px',
				color: $mol_theme.line,
			},
		},
		
		Item: {
			flex: {
				direction: 'column',
			},
			align: {
				items: 'center',
			},
			// gap: '1.5rem',
		},
		Item_row: {
			width: '100%',
		},
		
		List: {
			flex: {
				direction: 'column',
			},
			// gap: '1.5rem',
		},

		Widget_controls: {
			background: {
				color: $mol_theme.card,
			},
			flex: {
				grow: 1,
			},
		},
		
		Widget_delete: {
			color: '#ff6666',
		},

		Add: {
			align: {
				self: 'center',
			},
		},

	} )
	
}
